import React from "react";
import { FC } from "react";
import { ComponentProps } from "react";
import { Field } from "react-final-form";
import Autocomplete from "../../../../components/Autocomplete";
import useUserQueries from "../../hooks/useUserQueries";
import { useQuery } from "react-query";

const StudentCountriesField: FC<ComponentProps<any>> = React.memo(
  (props: any) => {
    const { fetchStudentCountries } = useUserQueries();
    const { isLoading, isFetching, data } = useQuery<any>(
      "studentCountries",
      fetchStudentCountries,
    );

    return (
      <Field
        loading={(isFetching || isLoading).toString()}
        options={data?.data}
        disabled={isLoading || isFetching}
        component={Autocomplete}
        {...props}
      />
    );
  },
);

export default StudentCountriesField;
